/* =============================================================================
   ts-contact-app-form.js

   Loaded by ts-contact.liquid ONLY when an app block (HulkApps form widget) is
   present. The theme's own contact form is never touched: every handler starts
   by resolving the event target to the nearest .ts-contact__form-app-blocks
   wrapper and bails out when there isn't one.

   Does three things inside that wrapper:
     1. Copies each field label into its placeholder, then hides the label
     2. Rejects free / personal / disposable email addresses
     3. Disables submit while Address Type is set to Residential

   Everything is wrapped in try/catch and only registers listeners, so a failure
   here can never prevent the app form from rendering or submitting.
   ========================================================================== */

(function () {
  'use strict';

  if (window.tsContactAppFormLoaded) return;
  window.tsContactAppFormLoaded = true;

  try {
    /* ---------- Config -------------------------------------------------- */

    var ROOT_SELECTOR = '.ts-contact__form-app-blocks';
    var EMAIL_SELECTOR = '#email-field-business-filter';

    var MESSAGE =
      'Please enter your business email address — free, personal and temporary email accounts are not accepted.';
    var CHECKING_MESSAGE = 'Checking your email address…';

    // Live disposable-domain lookup for domains missing from the list below.
    // Set to false to rely on the local list only.
    var USE_REMOTE_CHECK = true;
    var REMOTE_ENDPOINT = 'https://open.kickbox.com/v1/disposable/';
    var REMOTE_TIMEOUT_MS = 4000;

    var ADDRESS_TYPE_SELECTOR = '#form_input_5, select[name="Address Type"]';
    var RESIDENTIAL_VALUES = ['residential'];
    var RESIDENTIAL_MESSAGE =
      'We can only accept business or practice addresses through this form.';

    // Always allowed, even if listed below (add client exceptions here).
    var ALLOWED_DOMAINS = [];

    var BLOCKED_DOMAINS = [
      'gmail.com', 'googlemail.com',
      'outlook.com', 'outlook.co.uk', 'outlook.fr', 'outlook.de', 'outlook.es',
      'outlook.it', 'outlook.com.au', 'outlook.in', 'hotmail.com', 'hotmail.co.uk',
      'hotmail.fr', 'hotmail.de', 'hotmail.es', 'hotmail.it', 'hotmail.ca',
      'hotmail.com.au', 'live.com', 'live.co.uk', 'live.ca', 'live.com.au',
      'live.fr', 'live.de', 'live.nl', 'msn.com', 'passport.com',
      'yahoo.com', 'yahoo.co.uk', 'yahoo.ca', 'yahoo.com.au', 'yahoo.co.in',
      'yahoo.in', 'yahoo.fr', 'yahoo.de', 'yahoo.es', 'yahoo.it', 'yahoo.com.br',
      'yahoo.com.mx', 'yahoo.co.jp', 'ymail.com', 'rocketmail.com',
      'aol.com', 'aol.co.uk', 'aim.com', 'verizon.net', 'frontier.com',
      'icloud.com', 'me.com', 'mac.com',
      'proton.me', 'protonmail.com', 'protonmail.ch', 'pm.me', 'tutanota.com',
      'tutanota.de', 'tuta.io', 'tuta.com', 'hushmail.com', 'mailfence.com',
      'startmail.com', 'posteo.de', 'runbox.com', 'fastmail.com', 'fastmail.fm',
      'gmx.com', 'gmx.net', 'gmx.de', 'gmx.at', 'gmx.ch', 'web.de', 'freenet.de',
      't-online.de', 'mail.com', 'email.com', 'usa.com', 'consultant.com',
      'zoho.com', 'zohomail.com', 'yandex.com', 'yandex.ru', 'ya.ru',
      'mail.ru', 'inbox.ru', 'list.ru', 'bk.ru', 'rambler.ru',
      'qq.com', 'foxmail.com', '163.com', '126.com', 'sina.com', 'sina.cn',
      'naver.com', 'daum.net', 'hanmail.net', 'nate.com',
      'rediffmail.com', 'sify.com', 'indiatimes.com',
      'seznam.cz', 'wp.pl', 'o2.pl', 'onet.pl', 'interia.pl',
      'libero.it', 'virgilio.it', 'alice.it', 'tiscali.it', 'tin.it',
      'orange.fr', 'wanadoo.fr', 'free.fr', 'laposte.net', 'sfr.fr', 'bbox.fr',
      'terra.com.br', 'uol.com.br', 'bol.com.br', 'ig.com.br',
      'telus.net', 'shaw.ca', 'sympatico.ca', 'rogers.com', 'bell.net',
      'btinternet.com', 'sky.com', 'talktalk.net', 'virginmedia.com', 'ntlworld.com',
      'comcast.net', 'sbcglobal.net', 'att.net', 'bellsouth.net', 'cox.net',
      'charter.net', 'earthlink.net', 'juno.com', 'netzero.net', 'optonline.net',
      'roadrunner.com', 'rr.com', 'windstream.net', 'q.com', 'centurylink.net',
      'bigpond.com', 'bigpond.net.au', 'optusnet.com.au', 'iinet.net.au', 'tpg.com.au',
      'xtra.co.nz', 'telkomsa.net', 'webmail.co.za',
      'excite.com', 'lycos.com', 'angelfire.com', 'tripod.com',
      'gawab.com', 'inbox.com', 'care2.com', 'operamail.com', 'hush.com',
      'mailinator.com', 'mailinator.net', 'guerrillamail.com', 'guerrillamail.net',
      'sharklasers.com', 'grr.la', 'spam4.me', '10minutemail.com', '10minutemail.net',
      'tempmail.com', 'temp-mail.org', 'temp-mail.io', 'tempmail.net', 'tempmail.dev',
      'tempr.email', 'throwawaymail.com', 'yopmail.com', 'yopmail.fr', 'yopmail.net',
      'trashmail.com', 'trashmail.de', 'trashmail.net', 'dispostable.com',
      'getnada.com', 'nada.email', 'moakt.com', 'moakt.cc', 'mailnesia.com',
      'maildrop.cc', 'fakeinbox.com', 'mytemp.email', 'emailondeck.com',
      'burnermail.io', 'mailcatch.com', 'spambog.com', 'spamgourmet.com',
      'anonaddy.com', 'anonaddy.me', 'simplelogin.com', 'simplelogin.io',
      'duck.com', 'relay.firefox.com', 'mozmail.com', 'privaterelay.appleid.com',
      'jetable.org', 'discard.email', 'discardmail.com', 'e4ward.com',
      'incognitomail.com', 'mailtemp.info', 'linshiyouxiang.net', 'cs.email',
      'inboxkitten.com', 'tmail.ws', 'mail7.io', 'harakirimail.com',
      'mohmal.com', 'emailfake.com', 'fakemail.net', 'tempinbox.com',
      'mailsac.com', 'mail-temporaire.fr', 'minuteinbox.com', 'tempmailo.com',
      'internxt.com', 'byom.de', 'armyspy.com', 'cuvox.de', 'dayrep.com',
      'einrot.com', 'fleckens.hu', 'gustr.com', 'jourrapide.com', 'rhyta.com',
      'superrito.com', 'teleworm.us', 'thetempmail.com', 'luxusmail.org',
      'candaba.com', '1secmail.com', '1secmail.org', '1secmail.net',
      'esiix.com', 'wwjmp.com', 'xojxe.com', 'yoggm.com', 'txcct.com',
      'kzccv.com', 'qiott.com', 'vjuum.com', 'laafd.com', 'dpptd.com',
      'oosln.com', 'vusra.com', 'zlork.com', 'ovooo.com', 'rteet.com',
      'dygov.com', 'ttirv.com', 'vaptu.com', 'cazlp.com', 'nuclene.com',
      'sotypid.com', 'dropjar.com', 'givmail.com', 'vixletdev.com',
      'hostcalls.com', 'knowledgemd.com', 'gmailner.com', 'lyricspad.net',
      'somelora.com', 'ezztt.com', 'chrisdel.com', 'rungel.net', 'jaggernaut.com'
    ];

    /* ---------- Scope guard ---------------------------------------------
       Every handler runs through this. No app-block wrapper, no action —
       which is what keeps the theme's own contact form untouched.
    --------------------------------------------------------------------- */

    function rootOf(node) {
      if (!node || !node.closest) return null;
      return node.closest(ROOT_SELECTOR);
    }

    function roots() {
      return document.querySelectorAll(ROOT_SELECTOR);
    }

    /* ---------- Section settings ----------------------------------------
       Each guard can be switched off per section from the theme editor.
       The wrapper carries the values as data attributes; anything other than
       the string "false" counts as on, so a missing attribute stays enabled.
    --------------------------------------------------------------------- */

    function optionOn(root, name) {
      return !root || root.getAttribute(name) !== 'false';
    }

    function placeholdersOn(root) {
      return optionOn(root, 'data-ts-placeholders');
    }

    function emailFilterOn(root) {
      return optionOn(root, 'data-ts-email-filter');
    }

    function remoteCheckOn(root) {
      return USE_REMOTE_CHECK && optionOn(root, 'data-ts-remote-check');
    }

    function residentialLockOn(root) {
      return optionOn(root, 'data-ts-residential');
    }

    /* ---------- 1. Labels into placeholders ------------------------------ */

    var TEXT_TYPES = ['text', 'email', 'tel', 'number', 'url', 'search'];

    function applyPlaceholders(root) {
      if (!placeholdersOn(root)) return;

      var labels = root.querySelectorAll('label');
      var i = labels.length;
      while (i--) {
        var label = labels[i];
        if (label.getAttribute('data-ts-done') === '1') continue;

        var wrap = label.parentElement;
        var field = wrap ? wrap.querySelector('input, textarea') : null;
        if (!field && label.htmlFor) {
          try {
            field = root.querySelector('#' + CSS.escape(label.htmlFor));
          } catch (err) {}
        }
        if (!field) continue;

        var type = (field.getAttribute('type') || 'text').toLowerCase();
        var isText =
          field.tagName === 'TEXTAREA' || TEXT_TYPES.indexOf(type) !== -1;
        if (!isText) continue;

        var text = (label.textContent || '').replace(/\*\s*$/, '').trim();
        if (!text) continue;

        field.setAttribute('placeholder', text);
        field.setAttribute('aria-placeholder', text);
        if (!field.getAttribute('aria-label')) {
          field.setAttribute('aria-label', text);
        }
        label.style.setProperty('display', 'none', 'important');
        label.setAttribute('data-ts-done', '1');
      }
    }

    /* ---------- 2. Business email only ----------------------------------- */

    function domainOf(value) {
      var s = String(value || '').trim().toLowerCase();
      var at = s.lastIndexOf('@');
      if (at === -1) return '';
      return s.slice(at + 1).replace(/[.\s]+$/, '');
    }

    // Matches the domain itself and any subdomain (mail.gmail.com -> gmail.com)
    function inList(domain, list) {
      var i = list.length;
      while (i--) {
        var d = list[i];
        if (domain === d || domain.slice(-(d.length + 1)) === '.' + d) return true;
      }
      return false;
    }

    var remoteCache = {};
    var remotePending = {};

    function remoteCheck(domain, useRemote, done) {
      if (!useRemote || !window.fetch || !domain) return done(false);
      if (remoteCache.hasOwnProperty(domain)) return done(remoteCache[domain]);

      if (remotePending[domain]) {
        remotePending[domain].push(done);
        return;
      }
      remotePending[domain] = [done];

      var settled = false;
      var finish = function (disposable) {
        if (settled) return;
        settled = true;
        remoteCache[domain] = disposable;
        var queue = remotePending[domain] || [];
        delete remotePending[domain];
        var i = -1;
        while (++i !== queue.length) queue[i](disposable);
      };

      setTimeout(function () {
        finish(false);
      }, REMOTE_TIMEOUT_MS);

      window
        .fetch(REMOTE_ENDPOINT + encodeURIComponent(domain), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit'
        })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          finish(!!(data && data.disposable));
        })
        .catch(function () {
          finish(false);
        });
    }

    function errorNode(field, create) {
      var host = field.parentNode;
      if (!host) return null;
      var node = host.querySelector('.ts-app-form__error');
      if (!node && create) {
        node = document.createElement('span');
        node.className = 'ts-app-form__error';
        node.setAttribute('role', 'alert');
        host.appendChild(node);
      }
      return node;
    }

    function showError(field, text, checking) {
      var node = errorNode(field, true);
      if (node) {
        node.textContent = text || MESSAGE;
        node.className = checking
          ? 'ts-app-form__error is-checking'
          : 'ts-app-form__error';
      }
      if (checking) return;
      field.classList.add('ts-app-form__invalid');
      field.setAttribute('aria-invalid', 'true');
      if (field.setCustomValidity) field.setCustomValidity(text || MESSAGE);
    }

    function clearError(field) {
      var node = errorNode(field, false);
      if (node && node.parentNode) node.parentNode.removeChild(node);
      field.classList.remove('ts-app-form__invalid');
      field.removeAttribute('aria-invalid');
      if (field.setCustomValidity) field.setCustomValidity('');
    }

    function focusField(field) {
      try {
        field.focus({ preventScroll: true });
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        field.focus();
      }
    }

    // 'ok' | 'blocked' | 'pending'
    function verdict(field, useRemote) {
      if (!field || !field.value.trim()) return 'ok';
      var domain = domainOf(field.value);
      if (!domain || domain.indexOf('.') === -1) return 'ok';
      if (inList(domain, ALLOWED_DOMAINS)) return 'ok';
      if (inList(domain, BLOCKED_DOMAINS)) return 'blocked';
      if (!useRemote || !window.fetch) return 'ok';
      if (remoteCache.hasOwnProperty(domain)) {
        return remoteCache[domain] ? 'blocked' : 'ok';
      }
      return 'pending';
    }

    /* ---------- 3. Residential lockout ----------------------------------- */

    function isResidential(select) {
      if (!select) return false;
      var raw = select.value;
      if (raw === undefined || raw === null || raw === '') return false;
      var text = String(raw).trim().toLowerCase();
      var i = RESIDENTIAL_VALUES.length;
      while (i--) {
        if (text.indexOf(RESIDENTIAL_VALUES[i]) !== -1) return true;
      }
      return false;
    }

    function setNote(root, show) {
      var wrap = root.querySelector('.form_submit_div');
      if (!wrap || !wrap.parentNode) return;
      var note = wrap.parentNode.querySelector('.ts-app-form__note');

      if (show && RESIDENTIAL_MESSAGE) {
        if (!note) {
          note = document.createElement('span');
          note.className = 'ts-app-form__note';
          note.setAttribute('role', 'alert');
          note.textContent = RESIDENTIAL_MESSAGE;
          wrap.parentNode.insertBefore(note, wrap.nextSibling);
        }
      } else if (note && note.parentNode) {
        note.parentNode.removeChild(note);
      }
    }

    function lockSubmit(root, locked) {
      var buttons = root.querySelectorAll(
        '.form_submit_div button, .form_submit_div .btn, button.nextBtn'
      );
      var i = buttons.length;
      while (i--) {
        var btn = buttons[i];
        var already = btn.getAttribute('data-ts-locked') === '1';
        if (locked) {
          if (already) continue; // idempotent, so the observer can't loop
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('data-ts-locked', '1');
          btn.style.setProperty('opacity', '0.45', 'important');
          btn.style.setProperty('cursor', 'not-allowed', 'important');
          btn.style.setProperty('pointer-events', 'none', 'important');
        } else if (already) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('data-ts-locked');
          btn.style.removeProperty('opacity');
          btn.style.removeProperty('cursor');
          btn.style.removeProperty('pointer-events');
        }
      }

      // The button itself can't show a cursor while it is disabled or has
      // pointer-events: none, so the not-allowed cursor lives on its wrapper.
      var wrap = root.querySelector('.form_submit_div');
      if (wrap) {
        if (locked) wrap.classList.add('ts-app-form__locked');
        else wrap.classList.remove('ts-app-form__locked');
      }

      setNote(root, locked);
    }

    function syncRoot(root) {
      try {
        applyPlaceholders(root);
        lockSubmit(
          root,
          residentialLockOn(root) &&
            isResidential(root.querySelector(ADDRESS_TYPE_SELECTOR))
        );
      } catch (err) {
        /* never let this break the app form */
      }
    }

    function syncAll() {
      try {
        var list = roots();
        var i = list.length;
        while (i--) syncRoot(list[i]);
      } catch (err) {}
    }

    /* ---------- Gate shared by submit and click -------------------------- */

    // Returns true when the event should be stopped.
    function shouldStop(root, retry) {
      if (
        residentialLockOn(root) &&
        isResidential(root.querySelector(ADDRESS_TYPE_SELECTOR))
      ) {
        lockSubmit(root, true);
        return true;
      }

      if (!emailFilterOn(root)) return false;

      var field = root.querySelector(EMAIL_SELECTOR);
      if (!field) return false;

      var state = verdict(field, remoteCheckOn(root));
      if (state === 'ok') {
        clearError(field);
        return false;
      }
      if (state === 'blocked') {
        showError(field);
        focusField(field);
        return true;
      }

      showError(field, CHECKING_MESSAGE, true);
      remoteCheck(domainOf(field.value), remoteCheckOn(root), function (disposable) {
        if (disposable) {
          showError(field);
          focusField(field);
        } else {
          clearError(field);
          if (typeof retry === 'function') retry();
        }
      });
      return true;
    }

    /* ---------- Bindings -------------------------------------------------- */

    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches(EMAIL_SELECTOR) || !rootOf(t)) return;
        clearError(t);
      },
      true
    );

    document.addEventListener(
      'blur',
      function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches(EMAIL_SELECTOR)) return;

        var root = rootOf(t);
        if (!root || !emailFilterOn(root)) return;
        if (!t.value.trim()) return clearError(t);

        var state = verdict(t, remoteCheckOn(root));
        if (state === 'blocked') return showError(t);
        if (state === 'ok') return clearError(t);

        remoteCheck(domainOf(t.value), remoteCheckOn(root), function (disposable) {
          if (disposable) showError(t);
        });
      },
      true
    );

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches(ADDRESS_TYPE_SELECTOR)) return;
        var root = rootOf(t);
        if (root) syncRoot(root);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        var root = rootOf(form);
        if (!root) return; // theme form — leave it alone

        if (shouldStop(root, function () {
            if (form.requestSubmit) form.requestSubmit();
            else form.submit();
          })) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    // The app's buttons submit via click handlers, so guard those too
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var btn = e.target.closest(
          '.form_submit_div button, .form_submit_div .btn, button.nextBtn, .nextBtn'
        );
        if (!btn) return;

        var root = rootOf(btn);
        if (!root) return; // theme form — leave it alone

        if (shouldStop(root, function () {
            btn.click();
          })) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    /* ---------- Initial run + re-render sync ------------------------------ */

    function watch() {
      try {
        syncAll();
        if (!window.MutationObserver) return;

        var list = roots();
        var i = list.length;
        while (i--) {
          (function (root) {
            if (root.getAttribute('data-ts-watched') === '1') return;
            root.setAttribute('data-ts-watched', '1');

            var pending = null;
            new window.MutationObserver(function () {
              if (pending) clearTimeout(pending);
              pending = setTimeout(function () {
                syncRoot(root);
              }, 120);
            }).observe(root, { childList: true, subtree: true });
          })(list[i]);
        }
      } catch (err) {
        if (window.console && console.warn) console.warn('[ts-contact app form]', err);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    // The app widget can mount after DOMContentLoaded, so re-scan briefly and
    // attach observers to any wrapper that appears late
    var tries = 0;
    var poll = setInterval(function () {
      watch();
      if (++tries > 20) clearInterval(poll);
    }, 500);
  } catch (err) {
    if (window.console && console.warn) console.warn('[ts-contact app form]', err);
  }
})();